import { ToolsClass } from '@/base/class/tools.class'
import { PAYWAY_GROUPS_TYPES, WALLET_TYPES } from '@/base/const/payway.const'

const WALLET_GROUP_TYPES = [PAYWAY_GROUPS_TYPES.googlePay, PAYWAY_GROUPS_TYPES.applePay]

/**
 * Który portfel ma stać wyżej na tym urządzeniu (PEP-1298).
 *
 * Kryterium to „Apple Pay działa tutaj” (`ApplePaySession.canMakePayments()`), a nie „urządzenie
 * Apple” z User-Agenta: Firefox na Macu dostałby wtedy wygaszony kafel Apple Pay nad działającym
 * Google Pay. Google Pay nie ma testu synchronicznego (SDKN-111), więc o kolejności decyduje
 * wyłącznie Apple Pay.
 *
 * @returns {string} PAYWAY_GROUPS_TYPES.applePay | PAYWAY_GROUPS_TYPES.googlePay
 */
export const getPreferredWalletGroupType = () =>
  ToolsClass.isWalletPaywayAvailable(WALLET_TYPES.applePay.id)
    ? PAYWAY_GROUPS_TYPES.applePay
    : PAYWAY_GROUPS_TYPES.googlePay

/**
 * Czy na liście są OBIE grupy rozdzielone (PEP-1249) - tylko wtedy kolejność portfeli istnieje.
 * Grupa zbiorcza `WALLET` nie podlega eksperymentowi.
 *
 * @param {array} groups
 * @returns {boolean}
 */
export const hasBothWalletGroups = (groups = []) =>
  WALLET_GROUP_TYPES.every((type) => groups.some((group) => group?.type === type))

/**
 * Zamienia MIEJSCAMI grupy `GOOGLE_PAY` i `APPLE_PAY`, jeśli preferowana stoi niżej.
 *
 * Zamiana, a nie przesunięcie na górę: pozostałe grupy zostają na indeksach ustawionych przez API,
 * prowizję i PaymentBoost (boost trzyma oba portfele na końcu, pod „pokaż więcej”).
 *
 * @param {array} groups
 * @param {string} preferredType
 * @returns {array} nowa tablica; wejście nie jest mutowane
 */
export const orderWalletGroups = (groups = [], preferredType) => {
  const result = [...groups]
  const otherType = WALLET_GROUP_TYPES.find((type) => type !== preferredType)
  if (!WALLET_GROUP_TYPES.includes(preferredType)) {
    return result
  }
  const preferredIdx = result.findIndex((group) => group?.type === preferredType)
  const otherIdx = result.findIndex((group) => group?.type === otherType)
  if (preferredIdx === -1 || otherIdx === -1 || preferredIdx < otherIdx) {
    return result
  }
  ;[result[preferredIdx], result[otherIdx]] = [result[otherIdx], result[preferredIdx]]
  return result
}
